import { render, staticRenderFns } from "./addChecklistFieldDialog.vue?vue&type=template&id=4a7faee0&lang=pug&"
import script from "./addChecklistFieldDialog.vue?vue&type=script&lang=js&"
export * from "./addChecklistFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./addChecklistFieldDialog.vue?vue&type=style&index=0&id=4a7faee0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports